import ConfigureIncidentDetectionModalContainer from './ConfigureIncidentDetectionModalContainer'

export default ConfigureIncidentDetectionModalContainer;